/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `UsersMostRecentProject.ts` file.
 ******/
import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

import { UsersMostRecentProject } from "./UsersMostRecentProject";

import { Team } from "./Team";
import { User } from "./User";

export abstract class UsersMostRecentProjectModel {
    id: number;
    activeOrder: number | null;
    createdAt: Dayjs;
    lastAccessed: Dayjs | null;
    projectUniqueToken: string | null;
    teamId: number | null;
    updatedAt: Dayjs;
    userId: number | null;
    team: Team | null | undefined;
    user: User | null | undefined;
    _destroy: boolean | undefined;

    constructor(
        id: number,
        activeOrder: number | null,
        createdAt: Dayjs,
        lastAccessed: Dayjs | null,
        projectUniqueToken: string | null,
        teamId: number | null,
        updatedAt: Dayjs,
        userId: number | null,
        team: Team | null | undefined,
        user: User | null | undefined
    ) {
        this.id = id;
        this.activeOrder = activeOrder;
        this.createdAt = createdAt;
        this.lastAccessed = lastAccessed;
        this.projectUniqueToken = projectUniqueToken;
        this.teamId = teamId;
        this.updatedAt = updatedAt;
        this.userId = userId;
        this.team = team;
        this.user = user;
    }

    static fromApiObject(json: any, timezone: string): UsersMostRecentProject {
        const newObject = new UsersMostRecentProject(
            json["id"],
            json["active_order"],
            dayjs(json["created_at"]).tz(timezone),
            json["last_accessed"] ? dayjs(json["last_accessed"]).tz(timezone) : null,
            json["project_unique_token"],
            json["team_id"],
            dayjs(json["updated_at"]).tz(timezone),
            json["user_id"],
            json["team"] == null ? json["team"] : Team.fromApiObject(json["team"], timezone),
            json["user"] == null ? json["user"] : User.fromApiObject(json["user"], timezone)
        );

        return newObject;
    }

    toApiObject(): any {
        return {
            id: this.id,
            active_order: this.activeOrder,
            created_at: this.createdAt,
            last_accessed: this.lastAccessed,
            project_unique_token: this.projectUniqueToken,
            team_id: this.teamId,
            updated_at: this.updatedAt,
            user_id: this.userId,
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): UsersMostRecentProject {
        const clone = Object.create(this) as UsersMostRecentProject;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
